import { Map, Record } from '@gonfalon/immutable-shim/immutableShim';
import type { ImmutableMap } from '@gonfalon/legacy-immutable/immutableUtils';

import type { Link } from '#utils/linkUtils';

type RelatedFlagProps = {
  _links: ImmutableMap<{
    parent: Link;
    self: Link;
  }>;
  _site: Link;
  key: string;
  name: string;
};

export class RelatedFlag extends Record<RelatedFlagProps>({
  _links: Map(),
  _site: Map(),
  key: '',
  name: '',
}) {
  selfLink() {
    return this._links.getIn(['self', 'href']);
  }

  siteLink(): string {
    return this._site.get('href');
  }
}
